module.exports = [{"code":0,"name":"未审批"},{"code":1,"name":"审批通过"},{"code":2,"name":"审批未通过"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/checkStatus.json
// module id = DTgU
// module chunks = 11